var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingCheck == 1)?_c('div',[_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loader"}),_c('p',[_vm._v(_vm._s(_vm.loadingMessage))]),_c('p',{staticClass:"margin-t-250"},[_vm._v(_vm._s(_vm.label.caption.loadingTxt))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }